export default __webpack_public_path__ + "static/media/announce_cross.354b1ac0.svg";